import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { buildRoutePath, routes } from '../../../constants/routes'

const KeyIssueTile = ({ keyIssue, filterObjects }) => {
    const [isPointMoved, setIsPointMoved] = useState(false)
    const [isTouchMoved, setIsTouchMoved] = useState(false)
    const cleanAlias = keyIssue?.alias.replace(/\/key-issues\//, '')
    const keyIssueSlug = cleanAlias.replace('in-depth', '')
    const filter = filterObjects?.find(f => f.name === keyIssue.category)
    const navigate = useNavigate()

    const handleTileClick = () => {
        // Dispatch a custom click event for analytics
        let dataLayer = window.dataLayer || []
        dataLayer.push({
            event: 'ki-tile-click',
            gtm: {
                element: {
                    dataset: {
                        id: `${keyIssue.title}`
                    }
                }
            }
        })
        const route = buildRoutePath(routes.keyIssueOverview.path, { keyIssueSlug: keyIssueSlug })
        navigate(route)
    }

    const handleKeyDown = (e) => {
        // Handle Enter or Space key press
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault()
            handleTileClick()
        }
    }
    return (
        <div
            role="button"
            tabIndex={0}
            aria-label={`Read about ${keyIssue.title}`}
            onKeyDown={handleKeyDown}
            onTouchStart={(evt) => {
                setIsTouchMoved(false)
            }}
            onTouchMove={() => {
                setIsTouchMoved(true)
            }}
            onTouchEnd={(evt) => {
                // if point moved, don't do any thing
                if (isTouchMoved) {
                    isTouchMoved(true)
                    return
                }
                // if point haven't moved, handle the click event as you wish
                handleTileClick()
            }}
            onPointerDown={(evt) => {
                setIsPointMoved(false)
            }}
            onPointerMove={() => {
                setIsPointMoved(true)
            }}
            onPointerUp={(evt) => {
                if (isPointMoved) {
                    setIsPointMoved(false)
                    return
                }
                // if point haven't moved, handle the click event as you wish
                handleTileClick()
            }}
            className="key-issue-tile"
            style={{ backgroundImage: `url(${keyIssue.tileImage?.url})` }}>
            <div className={`key-issue-label ${filter?.color}-bg`} >
                <span>{keyIssue.title}</span>
            </div>
        </div>
    )
}

export default connect()(KeyIssueTile)
